export default () => {
  const tabHeaders = document.querySelectorAll('.tabs__header');
  const tabContents = document.querySelectorAll('.tabs__body__content');

  tabHeaders.forEach(tabHeader => {
    tabHeader.addEventListener('click', () => {
      tabHeaders.forEach(header => {
        header.classList.remove('active');
      });

      tabContents.forEach(content => {
        content.classList.remove('active');
      });

      tabHeader.classList.add('active');

      const tabId = tabHeader.getAttribute('data-tab');

      const tabContent = document.getElementById(tabId);
      if (tabContent) {
        tabContent.classList.add('active');
      }
    });
  });
}
